import '../../components/styles/customstyle.scss'
import { AVAILABLE_ENTITIES, Repository, utils } from '../../database'
import React, { Component } from 'react'
import AppContent from '../../components/layout/AppContent'
import { connect } from 'react-redux'
import { withRouter } from '../../utils/withRouterCompat'
import { Box } from '@mui/material'
import Button from '../../components/material/Button'
import * as sync from '../../../src/syncWorker'
import { USUARIO, formatName } from '../../utils/formHelper'
import { getLoggedUser } from '../../redux/auth/actions'
import { logout } from '../../redux/auth/actions'

class Refresh extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  refresh() {
    sync.refreshApplication().then((res) => this.props.history.push('/'))
  }

  render() {
    return (
      <AppContent>
        <Box sx={{ mt: 3 }}>
          <Button label='refresh' onClick={() => this.refresh()} />
        </Box>
      </AppContent>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: async () => await dispatch(logout()),
    loggedUser: async () => await getLoggedUser(),
    user: async () =>
      await utils.getElement(AVAILABLE_ENTITIES.USERS, loggedUser.userId),
  }
}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Refresh))
